import {
  registerAlpineComponents,
  startAlpineOnce,
  initAlpineTree,
} from './alpine/initAlpine';
import InitNavigation from './initNavigation';
import { initGlobal, initAos } from './initGlobal';
import InitSwiper from './initSwiper';
import InitHome from './initHome';
import InitGsap from './initGsap';
import InitProduct from './initProduct';
import InitTitle from './initTitle';
import InitCart from './initCart';
import InitCheckout from './initCheckout';
import InitWish from './initWish';
import InitProductQna from './initProductQna';
import InitRequestModal from './initRequestModal.js';
import './modal.js';

const body = document.body;

registerAlpineComponents();

InitNavigation();
InitGsap();

initGlobal();
initAos();

if (body.classList.contains('home')) {
  InitHome();
} else if (body.classList.contains('single-product')) {
  InitProduct();
  InitProductQna();
} else if (body.classList.contains('woocommerce-cart')) {
  InitCart();
} else if (body.classList.contains('woocommerce-checkout')) {
  InitCheckout();
}

function boot() {
  startAlpineOnce();
  InitSwiper();
  InitWish();

  if (body.classList.contains('page-faq')) {
    InitRequestModal();
  }

  // InitTitle();
}

document.addEventListener('DOMContentLoaded', boot);
